import type { FaireProductEntity } from "../../entity_types/product";

export const p_k3g6nexf2c: FaireProductEntity = {
  token: "p_k3g6nexf2c",
  type: "product",
  name: "Sitting Buddha - Made from Durable Polyresin",
  brandToken: "b_6clm7lye",
  brandName: "Hi-Line Gift Ltd.",
  imageUrl:
    "https://cdn.faire.com/fastly/67c6c840e54da7a0c0137806c35d2c0077bcbdc189bb35c7c8f1a02e0f09ad37.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/efd86b83769b1a6a305acebaf8a8ea59cd06500ea1f7df9ee0e8f9884a568404.jpeg",
    "https://cdn.faire.com/fastly/699c6e1c1a09d4700e69ac84d17bdcab9707bb46ab1ebe3dd5cf1bfd5c416bae.jpeg",
    "https://cdn.faire.com/fastly/4dd077e97ab27844a5e66ce52ef131b0657124c5a4a2acdd9acf3ddfd3576daa.jpeg",
    "https://cdn.faire.com/fastly/8a05bedb939a7bee34b3eecdfdf15d146188880f444b48f3b1086008240f77d2.jpeg",
    "https://cdn.faire.com/fastly/21a7fd75c07411de022f1e99ce3b332fbfd4e5bfdddc2d52c75453c3344d306a.jpeg",
    "https://cdn.faire.com/fastly/48795ac3d7919e28da39f0778217c30b9e32c6f34cc65bb19bc3c4162bbe7a1f.jpeg",
    "https://cdn.faire.com/fastly/dae5ca1d0857c3e5dc69b549274ae5bdf7fe997e94b517e61e64f6b88109b0b3.jpeg",
    "https://cdn.faire.com/fastly/0fb0d46280d89fdf782359647bc626d167aba9d9a4851ae8136ae21283dedbc8.jpeg",
    "https://cdn.faire.com/fastly/510a034cafee87e19c1f4338500c89148f93f09c588dfb5e3b489038ef50f6a3.jpeg",
  ],
  priceDollars: 35.75,
  description:
    "Add this beautiful Buddha statue to create your own zen space. Made from durable polyresin. A perfect addition to your lawn or garden. Ideal for indoor and outdoor use.",
  tags: [],
  msrpDollars: 78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:44.328Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
